import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader, TranslocoLoaderData } from '@jsverse/transloco';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  public getTranslation(lang: string, data?: TranslocoLoaderData): Observable<Translation> {
    const scope = data?.scope;
    const actualLang = lang.includes('/') ? lang.split('/').pop() : lang;
    if (scope) {
      console.log(`[Transloco] Requesting Scope "${scope}" for "${actualLang}"...`);

      return this.http.get<Translation>(`/assets/i18n/${scope}/${actualLang}.json`).pipe(
        catchError((error) => {
          console.warn(`[Transloco] Failed to load scope: ${scope}/${actualLang}`, error);
          return of({});
        }),
        tap((res) => console.log(`[Transloco] Loaded Scope "${scope}" result:`, res))
      );
    }
    console.log(`[Transloco] Requesting Global Shared Files for "${actualLang}"...`);

    return forkJoin({
      common: this.loadFile(`/assets/i18n/shared/${actualLang}/common.json`),
      errors: this.loadFile(`/assets/i18n/shared/${actualLang}/errors.json`),
      validation: this.loadFile(`/assets/i18n/shared/${actualLang}/validation.json`),
      app: this.loadFile(`/assets/i18n/app/${actualLang}.json`),
    }).pipe(
      tap((res) => console.log(`[Transloco] Loaded Global translations result:`, res))
    );
  }

  private loadFile(path: string): Observable<Translation> {
    return this.http.get<Translation>(path).pipe(
      catchError((error) => {
        console.warn(`[Transloco] Failed to load file: ${path}`, error);
        return of({});
      })
    );
  }
}
